<template>
    <div class="index notranslate">
        <v-header :is-seft="1"></v-header>

        <mu-container class="content" v-show="!showOrderTip">
            <!-- Owner filter chips -->
            <div class="ower-filter">
                <span class="badge-num" :class="{select:current==-1}" @click="selectOwerCartlist(-1,null)">
                    <mu-icon value="people" size="16"></mu-icon>
                    <span>{{$t('orderList.all')}}</span>
                </span>
                <span class="badge-num" :class="{select:index==current}" @click="selectOwerCartlist(index,val)" v-for="(val, key, index) in cartOwerData" :key="index">
                    <mu-icon value="person" size="14"></mu-icon>
                    <span>{{key.replace(/\"/g,"")}}</span>
                </span>
            </div>

            <!-- Regular order items grouped by category -->
            <div class="cart-box" v-for="(val, key, index) in cartShowData" :key="index">
                <div class="category-header" v-if="hasCategoryName(key)">
                    <!-- <mu-icon value="restaurant" size="18"></mu-icon> -->
                    <span class="category-title">{{categoryName(key)}}</span>
                    <span class="category-count">{{val.length}}</span>
                </div>
                <div class="food-list">
                    <div class="food-item" v-for="item,idx in val" :key="idx">
                        <img class="food-img" :src="getImgUrl(item.foodImage,100)"/>
                        <div class="food-info">
                            <div class="food-name">{{item.foodName}}</div>
                            <div class="food-decide" v-if="item.decideName!=null && item.decideName!=''">
                                <mu-icon value="restaurant_menu" size="12"></mu-icon>
                                {{item.decideName}}
                            </div>
                            <div class="food-price-row">
                                <span class="unit-price">{{item.price}} {{seller.unit}}</span>
                                <span class="qty-x">x {{item.quantity}}</span>
                            </div>
                        </div>
                        <div class="item-total">
                            <span>{{item.quantity * item.price}} {{seller.unit}}</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Total row for regular items -->
            <div class="total-row" v-if="Object.keys(cartShowData).length > 0">
                <span class="total-label">{{$t('orderList.total')}}</span>
                <span class="total-value">{{total}} {{seller.unit}}</span>
            </div>

            <!-- Buffet expansion panels (batch orders) -->
            <div class="buffet-panels" v-if="cartBuffetShowData.length > 0">
                <div class="section-divider">
                    <span class="divider-text">{{$t('orderList.buffetBatches') || 'Buffet Batches'}}</span>
                </div>
                <mu-expansion-panel v-for="(batchGroup, i) in cartBuffetShowData" :key="batchGroup.batch" :expand="getExpand(i)" class="buffet-panel">
                    <div slot="header" class="panel-header">
                        <div class="panel-header-left">
                            <!-- <mu-icon value="restaurant" size="18"></mu-icon> -->
                            <span class="panel-title">{{getOrderTimes(batchGroup.batch)}}</span>
                        </div>
                        <!-- <span class="panel-badge">{{getBatchTotal(batchGroup.items)}} {{seller.unit}}</span> -->
                    </div>
                    <div class="cart-box buffet-cart" v-for="(val, key, index) in getTypeGroup(batchGroup.items)" :key="index">
                        <div class="category-header" v-if="hasCategoryName(key)">
                            <mu-icon value="label" size="16"></mu-icon>
                            <span class="category-title">{{categoryName(key)}}</span>
                            <span class="category-count">{{val.length}}</span>
                        </div>
                        <div class="food-list">
                            <div class="food-item small" v-for="item,idx in val" :key="idx">
                                <img class="food-img small" :src="getImgUrl(item.foodImage,100)"/>
                                <div class="food-info">
                                    <div class="food-name">{{item.foodName}}</div>
                                    <div class="food-decide" v-if="item.decideName!=null && item.decideName!=''">
                                        <mu-icon value="restaurant_menu" size="11"></mu-icon>
                                        {{item.decideName}}
                                    </div>
                                </div>
                                <div class="item-qty">x {{item.quantity}}</div>
                            </div>
                        </div>
                    </div>
                </mu-expansion-panel>
            </div>

            <!-- Bottom spacer -->
            <div class="bottom-spacer"></div>

            <!-- Footer bar -->
            <div class="order-footer">
                <div class="order-footer-btn">
                    <div class="order-footer-home" @click="jumpHome">
                        <mu-icon value="home" size="18"></mu-icon>
                        <span>{{$t('orderList.home')}}</span>
                    </div>
                </div>
            </div>
        </mu-container>

        <!-- Empty page -->
        <div class="empty-page" v-show="showOrderTip">
            <div class="empty-icon">🍽️</div>
            <div class="empty-title">{{$t('buffet.nullOrder')}}</div>
            <mu-button color="success" class="notranslate" @click="jumpBack" style="text-transform:unset;margin-top:20px;">
                {{$t('orderList.return')}}
            </mu-button>
        </div>

        <!-- Info drawer -->
        <mu-drawer :open.sync="open" :docked="docked" :right="true" width="100%">
            <div class="drawer-header">
                <span class="drawer-title">{{$t('orderList.info')}}</span>
                <mu-icon value="close" size="22" class="drawer-close" @click="open = false"></mu-icon>
            </div>
            <mu-form :model="tableOrderInfo" class="mu-demo-form drawer-form" label-position="right">
                <mu-form-item prop="TableName" label="Table">
                    <mu-text-field v-model="tableOrderInfo.tableName" readonly></mu-text-field>
                </mu-form-item>
                <mu-form-item prop="Name" :label="$t('login.name')">
                    <mu-text-field v-model="tableOrderInfo.name" readonly></mu-text-field>
                </mu-form-item>
                <mu-form-item :label="$t('login.telephone')" prop="Telephone">
                    <mu-text-field v-model="tableOrderInfo.telephone" readonly></mu-text-field>
                </mu-form-item>
                <mu-form-item :label="$t('login.number')" prop="Adult">
                    <mu-text-field v-model="tableOrderInfo.adult" readonly></mu-text-field>
                </mu-form-item>
                <mu-form-item :label="$t('login.beginTime')" prop="OrderTime">
                    <mu-text-field v-model="tableOrderInfo.orderTime" readonly></mu-text-field>
                </mu-form-item>
            </mu-form>
            <mu-list>
                <mu-list-item button @click="menuAddPackageLink" v-if="isSeft==1">
                    <mu-list-item-action style="min-width:36px;">
                        <mu-icon value="add_circle_outline" color="orange"></mu-icon>
                    </mu-list-item-action>
                    <mu-list-item-title>{{$t('orderList.morePeople')}}</mu-list-item-title>
                </mu-list-item>
            </mu-list>
        </mu-drawer>

        <mu-dialog :title="$t('orderList.orderChangeTip')" width="360" :open.sync="openOrderChange" :overlay-close="false" :esc-press-close="false">
            {{$t('common.orderstatechange')}}
            <mu-button slot="actions" flat color="primary" @click="jumpOrderChange" style="color: #da5b3a;"> {{$t('common.sure')}}</mu-button>
        </mu-dialog>
    </div>
</template>
<script>
    import header from '../components/Header';
    export default {
        name: 'OrderBill',
        data() {
            return {
                title: 'Order bill',
                seller: {},
                showFullScreen: true,
                tableOrderInfo: {},
                total:0,
                cartList: [],
                groupCartList: [],
                groupCartBuffetList: [],
                cartShowData: {},
                cartBuffetShowData: {},
                showOrderTip: false,
                isSeft: 0,
                docked: false,
                open: false,
                current: -1,
                cartOwerData: {},
                openOrderChange: false,
                timer: null,
                configsData: {},
                singleOrderId: null
            }
        },
        components: {
            'v-header': header
        },
        mounted() {
            if ("undefined" != typeof api) {
                this.showFullScreen = false;
            }
            this.tableOrderInfo = this.getItem('sessionStorage','tableOrderInfo');
            this.seller = JSON.parse(window.localStorage.getItem('seller') || '{}');
            this.isSeft = this.$route.query.isSeft;
            this.getTitle();
            this.getOrderList();
            this.getConfigs();
            // 先清再设，防止路由重复进入时 timer 叠加
            if (this.timer) {
                clearInterval(this.timer);
                this.timer = null;
            }
            this.timer = setInterval(() => {
                this.checkOrder()
            }, 300000);
        },
        methods: {
            hasCategoryName(key) {
                var name = (key || '').replace(/"/g, '').trim();
                return name !== '' && name !== 'null' && name !== 'undefined';
            },
            categoryName(key) {
                var name = (key || '').replace(/"/g, '').trim();
                if (name === '' || name === 'null' || name === 'undefined') return '';
                return name;
            },
            jumpOrderChange() {
                this.openOrderChange = false;
                this.$router.push({
                    path: '/result'
                })
            },
            checkOrder() {
                let param = {
                    tableName: this.tableOrderInfo.tableName,
                    restaurantId: this.tableOrderInfo.restaurantId
                };
                // 单点模式：首次进入没有订单属于正常情况，校验逻辑走单独分支
                if (this.configsData.SingleService != null && String(this.configsData.SingleService) === '1') {
                    this.checkOrderSingle(param);
                    return;
                }
                this.$get('QRCodeOrder/GetUnpayOrderMainByTableName', param)
                    .then(response => {
                        if (response.code==200) {
                            var data = response.data;
                            if (data == null || data == '') {
                                window.clearTimeout(this.timer);
                                this.openOrderChange = true;
                            }
                        }
                    });
            },
            getConfigs() {
                if (!this.tableOrderInfo.restaurantId) return;
                this.$get('QRCodeBasicInfo/GetConfigs', { restaurantId: this.tableOrderInfo.restaurantId })
                    .then(response => {
                        if (response.code == 200) {
                            response.data.forEach((item) => {
                                this.configsData[item.configKey] = item.configValue;
                            });
                        }
                    });
            },
            // 单点模式订单校验：未记录订单时查未支付订单，空属正常不提示，首次拿到数据记录 orderId；
            // 已记录订单后用 CheckOrderState 校验订单是否仍存在，不存在说明订单状态已修改，弹出提示
            checkOrderSingle(param) {
                if (this.singleOrderId != null) {
                    this.$get('QRCodeOrder/CheckOrderState', { orderId: this.singleOrderId })
                        .then(response => {
                            if (response.code == 200) {
                                var stateData = response.data;
                                if (stateData == null || stateData == '') {
                                    window.clearTimeout(this.timer);
                                    this.singleOrderId = null;
                                    this.openOrderChange = true;
                                }
                            }
                        });
                    return;
                }
                this.$get('QRCodeOrder/GetUnpayOrderMainByTableName', param)
                    .then(response => {
                        if (response.code == 200) {
                            var data = response.data;
                            if (data == null || data == '') {
                                return;
                            }
                            this.singleOrderId = data.orderId;
                        }
                    });
            },
            menuAddPackageLink() {
                this.open = false;
                this.docked = true;
                this.$router.push({
                    path: '/buffetSelect'
                })
            },
            jumpHome() {
                this.$router.push({ path: '/buffet' });
                // if (this.isSeft == 0) {
                //             this.$router.push({ path: '/goodsMain' });
                //         }
                //         else {
                            
                //         }
            },
            getOrderList() {
                this.total = 0;
                let param = {
                    tableName: this.tableOrderInfo.tableName,
                    restaurantId: this.tableOrderInfo.restaurantId
                };
                this.$get('QRCodeOrder/GetUnpayOrderMainByTableName', param)
                    .then(response => {
                        if (response.code == 200) {
                            var data = response.data;
                            if (data == null || data == '') {
                                this.showOrderTip = true;
                                return;
                            }
                            this.tableOrderInfo.orderTime =  data.orderDay.replace('/Date(', '').replace(')/', '');
                            this.$get('QRCodeOrder/GetQRcodeOrderList', { orderId: data.orderId })
                                .then(result => {
                                    if (result.code == 200) {
                                        this.cartList = result.data;
                                        if (this.cartList.length == 0) {
                                            this.cartShowData = [];
                                            this.showOrderTip = true;
                                            return;
                                        }
                                        this.total = 0;
                                        this.showOrderTip = false;
                                        for (var i = 0; i < this.cartList.length; i++) {
                                            if(this.cartList[i].isSeft==0){
                                                this.total += (this.cartList[i].quantity * this.cartList[i].price);
                                            }
                                        }
                              
                                        this.cartOwerData = this.groupBy(this.cartList, (cart) => {
                                            return cart.createUser
                                        });
                                
                                        var map = {},
                                        dest = [];
                                        for (var i = 0; i < this.cartList.length; i++) {
                                            var ai = this.cartList[i];
                                            var isHas = false;
                                                for (var j = 0; j < dest.length; j++) {
                                                    var dj = dest[j];
                                                    if (dj.foodId == ai.foodId && dj.decideName == ai.decideName &&dj.batch == ai.batch) {
                                                        isHas=true;
                                                        dest.splice(j, 1);
                                                        dest.push({
                                                            orderId:ai.orderId,
                                                            foodId:ai.foodId,
                                                            foodName:ai.foodName,
                                                            decideName:ai.decideName,
                                                            price:ai.price,
                                                            foodDiscount: ai.foodDiscount,
                                                            foodImage: ai.foodImage,
                                                            foodTypeName: ai.foodTypeName,
                                                            quantity: ai.quantity + dj.quantity,
                                                            isSeft: ai.isSeft,
                                                            batch: ai.batch
                                                        });
                                                        break;
                                                    }
                                            }
                                            if (!isHas) {
                                                dest.push({
                                                    orderId: ai.orderId,
                                                    foodId: ai.foodId,
                                                    foodName: ai.foodName,
                                                    decideName:ai.decideName,
                                                    price: ai.price,
                                                    foodDiscount: ai.foodDiscount,
                                                    foodImage: ai.foodImage,
                                                    foodTypeName: ai.foodTypeName,
                                                    quantity: ai.quantity,
                                                    isSeft: ai.isSeft,
                                                    batch: ai.batch
                                                });
                                            }
                                        }
                                        this.groupCartList = [];
                                        this.groupCartBuffetList = [];
                                        for (var q = 0; q < dest.length; q++) {
                                            if (dest[q].isSeft == 0) {
                                                this.groupCartList.push(dest[q]);
                                            }
                                            else {
                                                this.groupCartBuffetList.push(dest[q]);
                                            }
                                        }
                                   
                                        this.cartShowData = this.groupBy(this.groupCartList, (cart) => {
                                            return cart.foodTypeName
                                        });
                                        // Reverse buffet list so newest (highest batch) comes first
                                        this.cartBuffetShowData = this.reverseGroupBy(this.groupCartBuffetList, (cart) => {
                                            return cart.batch
                                        });
                                    }
                                    else {
                                        this.showOrderTip = true;
                                    }
                                });
                        }
                    });
            },
            selectOwerCartlist(index, list) {
                this.current = index;
                let groupCartList = [];
                let groupCartBuffetList = [];
                if (list != null) {
                    for (var q = 0; q < list.length; q++) {
                        if (list[q].isSeft == 0) {
                            groupCartList.push(list[q]);
                        }
                        else {
                            groupCartBuffetList.push(list[q]);
                        }
                    }
                }
                else {
                    groupCartList = this.groupCartList;
                    groupCartBuffetList = this.groupCartBuffetList;
                }
                if (groupCartList.length > 0) {
                    var total = 0;
                    groupCartList.forEach(function (item) {
                        total += Math.round(item.quantity * item.price);
                    });
                    this.total = total;

                    this.cartShowData = this.groupBy(groupCartList, (cart) => {
                        return cart.foodTypeName
                    });
                }
                else {
                    this.cartShowData = [];
                }
                if (groupCartBuffetList.length > 0) {
                    this.cartBuffetShowData = this.reverseGroupBy(groupCartBuffetList, (cart) => {
                        return cart.batch
                    });
                }
                else {
                    this.cartBuffetShowData = [];
                }
            },
            getTypeGroup(val) {
               return this.groupBy(val, (cart) => {
                    return cart.foodTypeName
               });
            },
            getOrderTimes(times) {
                let txt = '';
                if (times == 1) {
                    txt = this.$t("orderList.frist")
                }
                else if (times == 2) {
                    txt = this.$t("orderList.second")
                }
                else if (times == 3) {
                    txt = this.$t("orderList.third")
                }
                else if (times == 4) {
                    txt = this.$t("orderList.fourth")
                }
                else {
                    txt = this.$t("orderList.moreth", { times: times });
                }
                return txt;
            },
            getExpand(index) {
                if (!this.cartBuffetShowData || this.cartBuffetShowData.length === 0) return false;
                const maxBatch = Math.max(...this.cartBuffetShowData.map(g => g.batch));
                return this.cartBuffetShowData[index] && this.cartBuffetShowData[index].batch === maxBatch;
            },
            getBatchTotal(items) {
                let sum = 0;
                if (Array.isArray(items)) {
                    items.forEach(i => sum += (i.quantity * i.price));
                } else {
                    for (let k in items) {
                        items[k].forEach(i => sum += (i.quantity * i.price));
                    }
                }
                return sum;
            },
            groupBy(list, fn) {
                const groups = {};
                list.forEach(function (o) {
                    const group = JSON.stringify(fn(o));
                    groups[group] = groups[group] || [];
                    groups[group].push(o);
                });
                return groups;
            },
            reverseGroupBy(list, fn) {
                const groups = {};
                list.forEach(function (o) {
                    const group = '__buf_' + JSON.stringify(fn(o));
                    groups[group] = groups[group] || [];
                    groups[group].push(o);
                });
                const sorted = Object.keys(groups)
                    .sort((a, b) => {
                        const ka = JSON.parse(a.replace('__buf_', ''));
                        const kb = JSON.parse(b.replace('__buf_', ''));
                        return kb - ka;
                    })
                    .map(key => ({
                        batch: JSON.parse(key.replace('__buf_', '')),
                        items: groups[key]
                    }));
                return sorted;
            },
            getImgUrl(image,w=0) {
                if (image == undefined || image == 'undefined' || image == null|| image == '') {
                    return '../static/img/default.png';
                }
                if(w==0){
                    return this.global.baseUrl + "uploads/" + image
                }
                return  this.global.baseUrl+"api/images/"+w+"/"+ image
            },
            refresh() {
                this.getOrderList();
                this.$toast.success('Refresh successfully!');
            },
            jumpIndex() {
                if (this.timeOutCheck()) {
                    this.$router.push({ path: '/buffet' });
                }
            },
            timeOutCheck() {
                let that = this;
                var time = window.localStorage.getItem('timeOut');
                if (time != undefined && time != null && time != "") {
                    var dateTimeStamp = new Date(time.replace(/-/g, '/')).getTime();
                    var now = new Date().getTime();
                    var diffValue = now - dateTimeStamp;
                    var minute = 1000 * 60;
                    var minC = diffValue / minute;
                    if (parseInt(minC) >= 120) {
                        this.$alert(this.$t("common.pageInvalid"), this.$t("common.alert"), {
                            type: 'warning', okLabel: this.$t("common.ok"),
                        }).then(function (result, value) {
                            that.$router.push({
                                path: '/error'
                            })
                        });
                        return false;
                    }
                    return true;
                }
                this.$alert(this.$t("common.pageInvalid"), this.$t("common.alert"), {
                    type: 'warning', okLabel: this.$t("common.ok"),
                }).then(function (result, value) {
                    that.$router.push({
                        path: '/error'
                    })
                });
                return false;
            },
            jumpBack() {
                if (this.timeOutCheck()) {
                    if (this.$route.query.isSeftPay != undefined && this.$route.query.isSeftPay != null) {
                        if ((this.isSeft == 0 && this.$route.query.isSeftPay == 1) || this.isSeft == 1) {
                            this.$router.push({ path: '/buffet' });
                        }
                        else {
                            this.$router.push({ path: '/buffet' });
                        }
                    }
                    else {
                        this.$router.go(-1);
                    }
                }
            },
            getTitle() {
                this.title = 'Bill list';
            },
            openDrawer() {
                this.open = !this.open;
                this.docked = false;
            },
        },
        activated() {
            this.getOrderList();
        },
        beforeDestroy() {
            // 清理轮询定时器，组件销毁后不再后台轮询
            if (this.timer) {
                clearInterval(this.timer);
                this.timer = null;
            }
        }
    }
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
    /deep/ .mu-expansion-toggle-btn.mu-button
        margin-right: 0px !important

    .nav-title
        text-align: center
        font-size: 18px

    .mu-list
        padding: 5px 0

    .mu-button
        text-transform: unset

    .material-icons
        font-size: 16px

    .content
        width: 100%
        height: 100%
        position: absolute
        padding-left: 0
        padding-right: 0
        padding-bottom: 70px
        overflow-y: auto
        -webkit-overflow-scrolling: touch
        background: #f7f4f0

    /* ===== Owner filter ===== */
    .ower-filter
        display: flex
        flex-wrap: wrap
        gap: 8px
        padding: 12px 14px
        background: #fff
        border-bottom: 1px solid #ece5db
    .ower-filter .material-icons
        margin-right: 4px
        vertical-align: middle

    .badge-num
        display: inline-flex
        align-items: center
        padding: 6px 14px
        font-size: 13px
        font-weight: 500
        background-color: #f0ebe3
        color: #8a7e6e
        border-radius: 18px
        cursor: pointer
        transition: all 0.2s
        float: none
        width: auto
        height: auto
        line-height: 1.4
        margin: 0
        overflow: visible
    .badge-num:active
        transform: scale(0.95)
    .badge-num.select
        background: linear-gradient(135deg, #da5b3a, #e8856b)
        color: #fff
        font-weight: 600
        box-shadow: 0 2px 6px rgba(218,91,58,0.35)

    /* ===== Cart box (per category) ===== */
    .cart-box
        position: relative
        margin: 10px
        background-color: #fff
        border-radius: 10px
        overflow: hidden
        box-shadow: 0 2px 8px rgba(218,91,58,0.08)

    .category-header
        display: flex
        align-items: center
        gap: 6px
        padding: 10px 14px 10px 16px
        font-size: 14px
        font-weight: 600
        color: #4a3b35
        background: linear-gradient(135deg, #f5efe6 0%, #e8ddd0 100%)
        border-left: 3px solid #da5b3a
        border-bottom: 1px solid #ece5db
    .category-header .material-icons
        color: #da5b3a
        font-size: 18px
    .category-title
        flex: 1
        color: #da5b3a;
    .category-count
        font-size: 12px
        color: #8a7e6e
        font-weight: 400
        background: #f0ebe3
        padding: 2px 8px
        border-radius: 10px

    /* ===== Food item ===== */
    .food-list
        padding: 0
    .food-item
        display: flex
        align-items: center
        padding: 12px 14px
        border-bottom: 1px solid #f2ece4
        gap: 12px
    .food-item:last-child
        border-bottom: none
    .food-img
        width: 64px
        height: 48px
        border-radius: 6px
        object-fit: cover
        flex-shrink: 0
        background: #f0ebe3
    .food-img.small
        width: 52px
        height: 40px
    .food-info
        flex: 1
        min-width: 0
    .food-name
        font-size: 14px
        font-weight: 600
        color: #3d2e28
        line-height: 1.3
        margin-bottom: 4px
    .food-decide
        display: flex
        align-items: center
        gap: 3px
        font-size: 11px
        color: #a08878
        margin-bottom: 4px
    .food-decide .material-icons
        font-size: 12px
    .food-price-row
        display: flex
        align-items: center
        gap: 6px
    .unit-price
        font-size: 12px
        color: #a08878
    .qty-x
        font-size: 12px
        color: #b89a88
        font-weight: 600
    .item-total
        flex-shrink: 0
        font-size: 15px
        color: #f01414
        font-weight: 700
    .item-qty
        flex-shrink: 0
        font-size: 14px
        color: #3d2e28
        font-weight: 700

    /* ===== Total row ===== */
    .total-row
        display: flex
        align-items: center
        justify-content: space-between
        margin: 12px 14px
        padding: 14px 16px
        background: linear-gradient(135deg, #fff5f2, #ffe8e0)
        border-radius: 10px
    .total-label
        font-size: 18px
        color: #3d2e28
        font-weight: 700
    .total-value
        font-size: 22px
        font-weight: 700
        color: #f01414

    /* ===== Buffet panels ===== */
    .buffet-panels
        margin-top: 10px
    .section-divider
        display: flex
        align-items: center
        margin: 14px 10px 8px
        gap: 10px
    .section-divider:before
        content: ''
        flex: 1
        height: 1px
        background: #ddd4c8
    .section-divider:after
        content: ''
        flex: 1
        height: 1px
        background: #ddd4c8
    .divider-text
        font-size: 13px
        color: #a08878
        font-weight: 600
        white-space: nowrap

    .buffet-panel
        margin: 6px 10px
        border-radius: 10px
        overflow: hidden
        box-shadow: 0 2px 8px rgba(218,91,58,0.08)
    .buffet-panel >>> .mu-expansion-panel
        border: none
        box-shadow: none
        background: #fff
    .buffet-panel >>> .mu-expansion-toggle-btn
        min-height: 56px !important
        height: auto !important
        display: flex !important
        align-items: center !important
    .buffet-panel >>> .mu-expansion-toggle-btn .mu-expansion-toggle-icon
        top: 50% !important
        transform: translateY(-50%) !important
    .panel-header
        display: flex
        align-items: center
        justify-content: space-between
        width: 100%
        padding: 14px 16px 14px 40px
        min-height: 56px
    .panel-header-left
        display: flex
        align-items: center
        gap: 6px
    .panel-title
        font-size: 14px
        font-weight: 600
        color: #3d2e28
    .panel-badge
        font-size: 13px
        font-weight: 700
        color: #f01414
    .buffet-cart
        margin: 8px 10px

    /* ===== Footer ===== */
    .bottom-spacer
        height: 20px

    .order-footer
        position: fixed
        bottom: 0
        left: 0
        right: 0
        display: flex
        height: 54px
        background: #fff
        box-shadow: 0 -2px 12px rgba(218,91,58,0.1)
        z-index: 100
    .order-footer-btn
        flex: 1
        height: 100%
    .order-footer-home
        height: 100%
        display: flex
        align-items: center
        justify-content: center
        gap: 6px
        font-size: 14px
        font-weight: 600
        width: 100%
        border-radius: 0
        background: linear-gradient(135deg, #da5b3a, #e8856b)
        color: #fff
        letter-spacing: 1px

    /* ===== Empty page ===== */
    .empty-page
        width: 100%
        background: #fff
        padding: 60px 20px
        text-align: center
    .empty-icon
        font-size: 60px
        margin-bottom: 16px
    .empty-title
        font-size: 16px
        font-weight: 600
        color: #da5b3a

    /* ===== Drawer ===== */
    .drawer-header
        display: flex
        align-items: center
        justify-content: center
        padding: 16px
        position: relative
        border-bottom: 1px solid #ece5db
    .drawer-title
        font-size: 18px
        font-weight: 600
        color: #3d2e28
    .drawer-close
        position: absolute
        top: 12px
        right: 12px
        cursor: pointer
        color: #a08878
    .drawer-form
        width: 90%
        margin: 16px auto
</style>



// WEBPACK FOOTER //
// src/components/OrderList.vue